import { BaseApiRouteService } from "mrb/core";

class BetaChannelApiRouteService extends BaseApiRouteService {
    find(filter) {
        return super.find(`${this.base}{?searchQuery,page,rpp,sort,embed}`, filter);
    }

    create() {
        return super.create(this.base);
    }

    delete(resource) {
        return super.delete(`${this.base}/{id}`, resource);
    }
}

export default BetaChannelApiRouteService;
